import { render, staticRenderFns } from "./AllAcount.vue?vue&type=template&id=486f656e&scoped=true&"
import script from "./AllAcount.vue?vue&type=script&lang=js&"
export * from "./AllAcount.vue?vue&type=script&lang=js&"
import style0 from "./AllAcount.vue?vue&type=style&index=0&id=486f656e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f656e",
  null
  
)

export default component.exports